@if (docDetails.length > 0) {
  <div class="detail-table-wrap">
    <table class="detail-table">
      <thead>
        <tr>
          <th>{{ 'Name_tr' | translate }}</th>
          <th>{{ 'hs_code_tr' | translate }}</th>
          <th>{{ 'Quantity_tr' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (detail of docDetails; track detail) {
          <tr>
            <td>{{ detail.name }}</td>
            <td>{{ detail.hsCode }}</td>
            <td>{{ detail.quantity }} {{ detail.unit }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}

<div class="list">
  @for (doc of documents; track doc) {
    <button
      class="document-tile"
      [class.document-tile--disabled]="isPixelated(doc)"
      [class.document-tile--removed]="isRemoved(doc)"
      [attr.data-testid]="isRemoved(doc) ? 'removed-document' : null"
      type="button"
      (click)="openDocument(doc)"
    >
      <div class="document-preview-frame">
        @if (isRemoved(doc)) {
          <div class="document-ribbon document-ribbon--removed">** {{ 'removed_document_tr' | translate }} **</div>
        } @else if (doc.pending) {
          <div class="document-ribbon">** {{ 'new_document_tr' | translate }} **</div>
        }
        @if (preview[doc.id]?.error_type) {
          <div class="document-preview-error">
            <mat-icon color="warn">error</mat-icon>
            <span>{{ 'document_preview_error_tr' | translate }}</span>
            <a href="mailto:support@supplycanvas.com" target="_blank" rel="noopener noreferrer">
              <mat-icon>support_agent</mat-icon>
              {{ 'Contact_Support_tr' | translate }}
            </a>
          </div>
        } @else if (preview[doc.id]?.preview) {
          <img
            [class.document-preview-pixelated]="isPixelated(doc)"
            [alt]="getDisplayTitle(doc)"
            [attr.src]="'data:image/png;base64,' + preview[doc.id].preview"
          />
        } @else {
          <div class="document-preview-placeholder">
            <mat-icon>web_asset_off</mat-icon>
          </div>
        }
      </div>

      <div class="document-meta">
        <div class="document-source">{{ doc | mapSourceName }}</div>
        @if (doc.date) {
          <div class="document-date">{{ doc.date | date: 'mediumDate' }}</div>
        }
        <h5>{{ getDisplayTitle(doc) }}</h5>
        <app-document-review-badge [status]="doc.status" [documentDate]="doc.date"></app-document-review-badge>
      </div>
    </button>
  }
</div>
